import React, { useState, useEffect } from 'react';
import './ScrollToTopButton.css'; // Bu stil dosyasını da oluşturacağız

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Kullanıcı sayfayı kaydırdığında, butonun görünürlüğünü kontrol eden fonksiyon
    const toggleVisibility = () => {
        // Eğer sayfanın dikey kaydırma pozisyonu 300 pikselden fazlaysa, butonu göster
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Sayfanın en üstüne yumuşak bir şekilde kaydıran fonksiyon
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Animasyonlu kaydırma için
        });
    };

    // Bileşen yüklendiğinde, 'scroll' olayını dinlemeye başla
    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);

        // Bileşen kaldırıldığında (unmount), olay dinleyicisini temizle
        // Bu, hafıza sızıntılarını (memory leaks) önler.
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="scroll-to-top">
            {isVisible && (
                <button onClick={scrollToTop} className="scroll-btn" title="Yukarı Çık">
                    <i className="fas fa-arrow-up"></i>
                </button>
            )}
        </div>
    );
};

export default ScrollToTopButton;